import React, { useEffect, useState } from "react";
import "./notificationDetails.scss";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import HeaderBar from "../../components/headerBar/HeaderBar";
import AnswerQuestionDetails from "../../components/answerQuestionDetails/AnswerQuestionDetails";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { setGlobalState, useGlobalState } from "../../utils/state";
import { getSingleNotificationsWS } from "./api/notificationDetailsApi";
import { Button, Dropdown } from "react-bootstrap";
import { isEmpty } from "../../utils/validation";
import { gestioneSnackbar } from "../../utils/common";

const NotificationDetails = ({ id }) => {
  const navigate = useNavigate();
  const [numberNotifications] = useGlobalState("numberNotifications");

  const { id_notification } = useParams();
  const [searchParams] = useSearchParams();
  const id_association = searchParams.get("admin");
  const id_event = searchParams.get("id_event");
  const question = searchParams.get("question");

  const [dataNotification, setDataNotification] = useState({});

  useEffect(() => {
    //se sono admin non mi devi spostare la pagina
    if (isEmpty(id_association)) {
      setGlobalState("selectedIdBottomBar", 5);
    }

    getSingleNotificationsWS({
      id_notification: id_notification ?? id,
      id_event: id_event ?? 0,
      question: question ?? 0,
      id_association,
    })
      .then((res) => {
        setDataNotification(res);
        //se non sono l'admin e se la notifica deve ancora essere letta allora ha senso che tu mi faccia anche l'update.
        if (isEmpty(id_association) && !res.displayed) {
          setGlobalState("numberNotifications", numberNotifications - 1);
        }
      })
      .catch((err) => {
        gestioneSnackbar(true, err.message, "error");
        navigate(-1);
      });
  }, [id_association, id_notification, question]);

  return (
    <>
      <HeaderBar title={t("notification_details.title")} back={true} />
      {!isEmpty(dataNotification) ? (
        <div className="notification-details-container container-responsive mt-3">
          {question === 0 || question === "0" ? (
            /*Nel caso di notifica legata ad un evento o a un singolo volontario*/
            <>
              <div className="header-notification">
                <div className="association-info">
                  <img
                    className="image-profile"
                    src={
                      dataNotification.image
                        ? "data:" +
                          dataNotification.image_type +
                          ";base64," +
                          dataNotification.image
                        : "/no_img.png"
                    }
                    alt="associazione"
                  />
                  <div className="name-association">
                    {dataNotification.name_association}
                  </div>
                </div>
                <div className="menu-icon">
                  <Dropdown>
                    <Dropdown.Toggle
                      as="button"
                      variant="light"
                      id="dropdown-menu"
                      className=" bg-transparent border-0 p-0"
                    >
                      <MoreVertIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ zIndex: 2 }}>
                      <Dropdown.Item disabled>
                        {dataNotification.datetime_sending}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className="content-notification mt-3">
                <div className="title-notification">
                  {dataNotification.title}
                </div>
                <p className="body-notification mt-2">
                  {dataNotification.body}
                </p>
              </div>
            </>
          ) : (
            /*Nel caso di risposta a una domanda da parte dell'associazione */
            <AnswerQuestionDetails
              id={dataNotification.id_question}
              image={
                dataNotification.image
                  ? "data:" +
                    dataNotification.image_type +
                    ";base64," +
                    dataNotification.image
                  : "/no_img.png"
              }
              name={dataNotification.name_association}
              datetime={dataNotification.datetime_sending}
              question={dataNotification.title}
              answer={dataNotification.body}
            />
          )}
        </div>
      ) : null}
    </>
  );
};

export default NotificationDetails;
